// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--9-oneOf-2-1!../../../node_modules/postcss-loader/src/index.js??ref--9-oneOf-2-2!../../../node_modules/postcss-loader/src/index.js??ref--9-oneOf-2-3!../../../node_modules/sass-loader/dist/cjs.js??ref--9-oneOf-2-4!./brand.module.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add CSS to Shadow Root
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesShadow.js").default
module.exports.__inject__ = function (shadowRoot) {
  add("bce09fe2", content, shadowRoot)
};